import React from 'react'

const Star = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path fill="#fff" fillOpacity=".9" d="M20.979 9.82c-.074-.211-.24-.365-.441-.403L14.99 8.57l-2.498-5.244C12.4 3.134 12.198 3 11.996 3s-.404.134-.496.327L9.02 8.59l-5.547.845c-.202.038-.386.192-.441.403-.074.212-.018.442.147.596l4.023 4.092-.955 5.783c-.037.21.055.441.22.576.165.134.404.154.588.038l4.96-2.728 4.96 2.728c.073.039.165.058.256.058.313 0 .551-.269.551-.576 0-.058 0-.096-.018-.135l-.937-5.744 4.023-4.092c.129-.173.184-.404.129-.615z"/>
  </svg>
)

export default Star
